import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { Polling } from '../../../shared/polling/Polling';
import rootStore from '../../../shared/stores/RootStore';
import { StoreName } from '../../../shared/stores/StoreName';
import { ProgressMonitorLayer } from '../../../shared/transportLayers/progress-monitor/ProgressMonitorLayer';
import ProgressBar from '../ProgressBar';
/**
 * Renders progress bar for progress monitor and automatically updates it. Serves as simpler declarative replacement
 * of `PollingHelper` from pricing. It simply renders progress bar, if `progressMonitorId` is provided, otherwise
 * nothing.
 *
 * @author Jan Prokop
 */

export var ProgressMonitorBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ProgressMonitorBar, _React$Component);

  function ProgressMonitorBar(props) {
    var _this;

    _classCallCheck(this, ProgressMonitorBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProgressMonitorBar).call(this, props));
    _this.messages = rootStore.getStore(StoreName.Message);
    _this.progressMonitorLayer = new ProgressMonitorLayer();

    _this.fetchStatus = function () {
      if (typeof _this.props.progressMonitorId === 'string') {
        return _this.progressMonitorLayer.status(_this.props.progressMonitorId);
      } else if (_this.props.progressMonitorId != null) {
        return _this.progressMonitorLayer.statusAggregation(_this.props.progressMonitorId);
      }

      return Promise.resolve({
        tag: 'done'
      });
    };

    _this.handleStatusResponse = function (error, response) {
      if (response) {
        switch (response.tag) {
          case 'new':
            _this.setState({
              percentage: 0
            });

            break;

          case 'working':
            _this.setState({
              percentage: Math.round(response.worked * 100 / response.total)
            });

            break;

          case 'done':
            _this.setState({
              percentage: 100
            });

            if (_this.props.onSuccess) {
              _this.props.onSuccess();
            }

            if (_this.props.onEnd) {
              _this.props.onEnd();
            }

            break;

          case 'failed':
            if (!_this.props.disableMessages) {
              _this.messages.setError(error || 'ERR_polling-failed');
            }

            if (_this.props.onError) {
              _this.props.onError();
            }

            if (_this.props.onEnd) {
              _this.props.onEnd();
            }

            break;

          default:
            throw new Error('Polling response state not supported');
        }
      }

      if (error) {
        throw error;
      }
    };

    _this.polling = new Polling(_this.props.interval);
    _this.state = {
      percentage: 0
    };
    return _this;
  }

  _createClass(ProgressMonitorBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (isMonitorActive(this.props.progressMonitorId)) {
        this.startPolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (isMonitorActive(this.props.progressMonitorId)) {
        this.stopPolling();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!isMonitorActive(this.props.progressMonitorId) && isMonitorActive(prevProps.progressMonitorId)) {
        this.stopPolling();
      } else if (isMonitorActive(this.props.progressMonitorId) && !isMonitorActive(prevProps.progressMonitorId)) {
        this.startPolling();
      }
    }
  }, {
    key: "startPolling",
    value: function startPolling() {
      this.polling.startPolling(this.fetchStatus, this.handleStatusResponse);
    }
  }, {
    key: "stopPolling",
    value: function stopPolling() {
      this.polling.stopPolling();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.alwaysVisible && !isMonitorActive(this.props.progressMonitorId)) {
        return null;
      }

      return React.createElement(ProgressBar, {
        percentage: this.state.percentage,
        label: this.props.label,
        className: this.props.className
      });
    }
  }]);

  return ProgressMonitorBar;
}(React.Component);

function isMonitorActive(progressMonitorId) {
  return progressMonitorId != null && progressMonitorId.length !== 0;
}